export enum Column {
  RELAY_NAME = 0,
  RELAY_IP = 1,
  CUSTOM_SERVER_NAME_IP = 2,
  LABEL = 3,
}

export enum ColumnKeys {
  RELAY_NAME = 'name',
  RELAY_IP = 'ip',
  CUSTOM_SERVER_NAME_IP = 'customHostname',
  LABEL = 'specifics.label',
}
